export default "/assets/images/spiral-calendar.png?71f79b72d91d079d50696df55f318577";